export const ITEMS_PER_PAGE = 30;

export const EMPTY_SEARCH_PARAMS = {
  tradeName: "",
  genericName: "",
  manufacturer: "",
};
